import { h5Css, Link } from '@atlassian/amkt-common';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import NamedLink from '../../../../records/NamedLink';

import styles from './NamedLinksFooterSection.less';

export const NamedLinksSectionHeading = styled.div`
  ${h5Css}
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 20px;
  margin-bottom: 0;
  text-transform: uppercase;
`;

export const NamedLinkListItem = styled.li`
  margin: 0;
`;

export default class NamedLinksFooterSection extends Component {
  static propTypes = {
    heading: PropTypes.string,
    namedLinks: ImmutablePropTypes.listOf(PropTypes.instanceOf(NamedLink)).isRequired,
    onLinkClick: PropTypes.func,
    openLinksInNewWindow: PropTypes.bool,
  };

  static defaultProps = {
    openLinksInNewWindow: false,
  };

  render() {
    return (
      <div className={styles.namedLinksFooterSection}>
        <NamedLinksSectionHeading>{this.props.heading}</NamedLinksSectionHeading>
        <ul className={styles.list}>
          {this.props.namedLinks.map((namedLink, i) => {
            return (
              <NamedLinkListItem key={`named-link-${i}`}>
                <Link
                  className={styles.link}
                  href={namedLink.link.href}
                  onClick={this.props.onLinkClick && this.onLinkClick.bind(this, namedLink)}
                  rel={this.props.openLinksInNewWindow ? 'noopener noreferrer' : undefined}
                  target={this.props.openLinksInNewWindow ? '_blank' : undefined}
                >
                  {namedLink.name}
                </Link>
              </NamedLinkListItem>
            );
          })}
        </ul>
      </div>
    );
  }

  onLinkClick = (namedLink, e) => this.props.onLinkClick(e, namedLink);
}
